import { Box } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

/** Grey dashed upload target that turns brand-colored on hover. */
export const DashedDropZone = styled(Box)(({ theme }) => ({
  border: `2px dashed ${theme.palette.grey[400]}`,
  borderRadius: Number(theme.shape.borderRadius) * 2,
  cursor: 'pointer',
  '&:hover': {
    borderColor: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.04),
  },
})) as typeof Box;
